<template>
    <div class="container mt-3">
        <div class="row">
            <div class="col-md-12 mb-3">
                <button class="btn btn-success btn-block text-white botaoGrande" @click="novoOrcamento">Solicitar Orçamento</button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mb-3">
                <button class="btn btn-warning btn-block text-white botaoGrande" @click="verificaPropostas">Verificar Propostas</button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mb-3">
                <button class="btn btn-danger btn-block text-white botaoGrande" @click="transportesAtivos">Verificar Transportes Contratados</button>
            </div>
        </div>
    </div>

</template>

<script>
// import { baseApiUrl } from '@/global'
// import axios from 'axios'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'clienteHome',
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            nome: '',
            level: '',
            email: ''
        }
    },
    methods: {
        novoOrcamento() {
            this.$router.push({ path: '/novoOrcamento' })
        },
        verificaPropostas() {
            this.$router.push({ path: '/propostas' })
        },
        transportesAtivos() {
            this.$router.push({ path: '/aceitosCliente' })
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.nome = decodedToken['data'].nome
                this.email = decodedToken['data'].email
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level !== 'cliente') {
            this.$router.push('/')
        }
    }
}
</script>

<style>
</style>